<!-- 根据语言类型按东西方习惯显示时间 -->

<template>
  <span>{{ showValue }}</span>
</template>

<script>
import moment from 'moment'


export default {
  name: "TimeFormat",
  components: {},
  props: {
    value: {
      type: [String, Number, Date],
    },
    format: {
      type: String,
      default() {
        return "YYYY-MM-DD HH:mm:ss";
      },
    },
    //是否是unix 时间
    isUnix: {
      type: Boolean,
      default: false,
    },
    isdebug: { type: Boolean, default: false },
  },

  data() {
    return {
      cloneValue: this.value,
    };
  },
  computed: {
    showValue() {
      let text = "";
      let locale = this.$i18n.locale;
      let format = this.format;
      let value = this.value;
      let isdebug = this.isdebug;

      if (value) {
        if (locale == "zh") {
          //todo
        } else if (locale == "en") {
          //todo
          format = format.replace("YYYY/MM/DD", "MM/DD/YYYY");
          format = format.replace("YY/MM/DD", "MM/DD/YY");
          format = format.replace("YYYY-MM-DD", "MM-DD-YYYY");
          format = format.replace("YY-MM-DD", "MM-DD-YY");
        } else if (locale == "es") {
          format = format.replace("YYYY/MM/DD", "DD/MM/YYYY");
          format = format.replace("YY/MM/DD", "DD/MM/YY");
          format = format.replace("YYYY-MM-DD", "DD-MM-YYYY");
          format = format.replace("YY-MM-DD", "DD-MM-YY");
        }
        if (typeof value === "string") {
          value = value.replace("T", " ");
          value = value.replace("Z", "");
        }

        text = this.formatTime(value, format, this.isUnix);
      } else {
        text = "-";
      }

      if (isdebug) {
        console.log(format);
        console.log(value);
        console.log(text);
        console.log("====");
      }

      return text;
    },
  },
  methods: {
    /**
 * 格式化日期
 * @param {*} val
 * @param {*} format
 * @param unix 是否是时间戳
 * @returns
 */
    formatTime(val, format = 'YYYY-MM-DD', unix = false) {
      if (val) {
        if (unix) {
          return moment.unix(val).format(format)
        }
        return moment(val).format(format)
      } else {
        return ''
      }
    }
  },
  mounted() { },
};
</script>


<style lang="scss" scoped></style>